import { render, staticRenderFns } from "./FormRecordDetail.vue?vue&type=template&id=33a303a0&lang=true&"
import script from "./FormRecordDetail.vue?vue&type=script&lang=js&"
export * from "./FormRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./FormRecordDetail.vue?vue&type=style&index=0&id=33a303a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports